<template>
  <div>
    <div class="my-6">
      <h3>{{ $t("views.report.title") }}</h3>
      <v-subheader>
        {{ $t("views.report.subtitle") }}
      </v-subheader>
    </div>

    <template v-if="selection.length > 0">
      <v-text-field
        v-model="name"
        :rules="rules.name"
        clearable
        outlined
        :label="$t('commons.title')"
        :placeholder="$t('commons.title_placeholder')"
      ></v-text-field>

      <v-text-field
        v-model="title"
        :rules="rules.title"
        clearable
        outlined
        :label="$t('commons.sub_title')"
        :placeholder="$t('commons.sub_title')"
      ></v-text-field>

      <avs-button
        @click="create()"
        :disabled="isDisabled"
        :loading="loading"
        block
        outlined
        x-large
        noSpantext
        iconI="mdi-printer"
        color="accent"
      >
        <template v-slot:name>
          {{ $t("actions.create", { entity: $t("commons.report") }) }}
        </template>
      </avs-button>
      <AvsList class="my-6">
        <draggable v-model="selection">
          <v-list-item
            v-for="(item, idx) in selection"
            :key="idx"
            icon
            class="elevation-1"
          >
            <v-list-item-icon>
              <v-icon>mdi-drag</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{ item.name }}</v-list-item-content>
            <v-list-item-action>
              <v-btn
                @click="remove(idx)"
                icon
                text
              >
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </draggable>
      </AvsList>
    </template>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import DocumentationService from "@/services/DocumentationService"
import { max64, required } from "@/utils/validator"

export default {
  components: {
    AvsList: () => import("@/components/generics/general/AvsList.vue"),
    draggable
  },
  props: {
    value: { type: Array, required: true }
  },
  computed: {
    isDisabled() {
      return !(this.name && this.name.length > 0) || this.loading
    },
    projectId() {
      return this.$store.state.app.project.id
    },
    selection: {
      get() {
        // Do not use ref, prefer creating a copy of object
        return [...this.value]
      },
      set(value) {
        this.$emit("hasChanged", value)
      }
    }
  },
  data: () => ({
    loading: false,
    name: "",
    title: "",
    rules: {
      name: [required, max64],
      title: []
    }
  }),
  methods: {
    remove(index) {
      // Do not update ref, prefer overwrite object to trigger $emit
      this.selection = this.selection.toSpliced(index, 1)
    },
    create() {
      this.loading = true

      // Build report object
      let report = {
        files: this.value.map(e => ({ id: e.id, file_type: e.file_type })),
        name: this.name,
        title: this.title,
        lang: this.$i18n.locale
      }

      // Create report
      DocumentationService.createReport(this, this.projectId, report)
        .then(result => {
          result.file_url = result.report
          this.$emit("created", result)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
